import { db, stage, cvGetDataUndoPush, cvGetFileDataToSave } from './draw';
import { Messages } from 'src/app/shared/constant/messages';
import * as createjs from "createjs-module";
import * as symConst from 'src/app/shared/constant/canvasSymTypes'; 
import {PenItemType, ZERO_PT, cvPointType, STATE_NORMAL_PEN_ITEM, STATE_DRAW_PEN_ITEM, 
    STATE_EDIT_PEN_ITEM} from 'src/app/shared/constant/drawConstants.ts'; 
//import * as drawConst from 'src/app/shared/constant/draw-tool-api'; 
import {DrawToolType,DT_DRAW_MODE,DT_DRAW_MODE_2,DT_EDIT_MODE,DT_TOOL_POINT,
    DT_TOOL_LINE,DT_TOOL_MULTI_LINE,DT_TOOL_FREEHAND,DT_TOOL_SHAPE,DT_TOOL_ERASER,
    DT_END_POINT_NONE, DT_MULTI_LINE_JOINT_NONE,DT_SHAPE_CIRCLE, DT_SHAPE_SQUARE,
    DT_SHAPE_RECT,DT_SHAPE_RIGHT_TRIANGLE, DT_SHAPE_TRIANGLE, DT_HIGHLIGHT_OFF, 
    DT_SHAPE_OUTLINE, DT_SHAPE_SOLID,DT_LINE_OPACITY_SOLID, DT_LINE_SIZE_1, 
    DT_COLOR_1, DT_HIGHLIGHT_LINE_SIZE_1, DT_COLOR_15, DT_LINE_TYPE_SOLID,
    DT_END_POINT_DOT, DT_END_POINT_OPEN_DOT,DT_END_POINT_ARROW,DT_LINE_SIZE_2,
    DT_HIGHLIGHT_LINE_SIZE_3, DT_MULTI_LINE_CLOSED,DT_LINE_OPACITY_HIGHLIGHT_1,
    DT_LINE_OPACITY_HIGHLIGHT_2,
    DT_END_POINT_ARROW_DOT,DT_HIGHLIGHT_ON,DT_MULTI_LINE_JOINT_DOT}
    from 'src/app/shared/constant/draw-tool-api'; 
import {
    CvDrawingBoard, MathFileType, STATE_NORMAL, STATE_OPEN_FILE, STATE_IN_PEN_TOOL, MProbType, MLineType, MBranchType,
    SymbolType, SymbolLong, SymbolSimple,STATE_IN_DRAW_MULTI,
  } from 'src/assets/js/cv-classes.js';
import {getCorrectXY,pushPenItemPt, adjustStart, adjustEnd,setPenShapeFill,setPenShapeStroke,checkPenShapeStroke,
    checkPenShapeColor,movePenLayerBehindMath,doStageUpdate,movePenLayerToTop} 
    from 'src/assets/js/cv-helpers.js';
import {watchEditDragPoints,hideEditPoints,showEditPoints,handleMovePoint,watchMoveEditedPenObj,clearPenMoveObj,
    setMoveBackground,checkAndEdit, watchEdit}
    from 'src/assets/js/cv-pen-edit.js';
   

  // create a layer over the whole canvas for the draw tool, which will be brought to the
// front of the canvas.  Create a background image of .01 alpha to prevent math problems from 
// getting key clicks while on the draw layer
export class penPt {
    constructor(x,y) {
        this.x = x;
        this.y = y;
    }
}

export function initPen() {
    //console.log("INIT PEN");

    if (db.penLayer == null)  {
        
        db.penBackground = new createjs.Shape();
        db.penBackground.graphics.beginFill("ghostwhite");
        db.penBackground.graphics.rect(0,0,stage.canvas.width,stage.canvas.height);     
        db.penBackground.x = 0;
        db.penBackground.y = 0;
        db.penBackground.name = "pen background";
        db.penBackground.alpha = .1;
        
        db.penLayer = new createjs.Container();
        if (db.inIpad) {
            db.stageDragContainer.addChild(db.penLayer);
        }
        else {
            stage.addChild(db.penLayer);
        }
        db.penLayer.addChild(db.penBackground);
        //db.penLayer.addEventListener("mousedown", handlePenDown); 
    }

    // in some odd cases such as cancels from file opens, canvas will get reloaded by pen not set
    // so set it back to defaults if so. 
    if (db.pen == null) {
        setDrawObjToDefault();
    }
}

//resize the pen background after a page has been added by canvas math
export function resizePenBackground() {
    db.penBackground.graphics.clear();
    db.penBackground.graphics.beginFill("ghostwhite");
    db.penBackground.graphics.rect(0,0,stage.canvas.width,stage.canvas.height);  
    db.penBackground.alpha = .1; 

    doStageUpdate();
}

// Make the pen layer active.  Create or activate a pen background layer to cover up the math problems so that 
// only pen tool mouse handles will get called
export function startPen() {
    //console.log("startpen");

    db.inPen = true;
    if (db.penLayer == null) {
        initPen();
    }
    else {
        db.penBackground.visible = true;
        movePenLayerToTop();
    }
    choosePenWatcher();
    doStageUpdate();
}

function choosePenWatcher() {
    //console.log("in choose penwatcher");
   
    // check if edit points of current pen object are shown, and hide them if shown
  
    if (db.curPenIndex >= 0 && db.penItemList[db.curPenIndex].pointsVisible) {
        hideEditPoints(db.penItemList[db.curPenIndex]);
    }

    let canvas = document.getElementById('drawingboard');
    canvas.classList.remove("grab-cursor");
    canvas.classList.remove("grabbing-cursor");
    canvas.classList.add("default-cursor");
    
    if (db.pen.drawMode == DT_EDIT_MODE) {
        db.penLayer.addEventListener('mousedown', watchEdit);
    } else {

        switch(db.pen.toolType) {
            case DT_TOOL_POINT:
                db.penLayer.addEventListener("click", watchPoint);
            break;
            case DT_TOOL_LINE:
                db.penLayer.addEventListener('mousedown',watchSingleLine);
            break;
            case DT_TOOL_MULTI_LINE:
                // since multi line requires a series of clicks, do the event listener in the routine
                watchMultiLine();
            break;
            case DT_TOOL_SHAPE:
                switch(db.pen.shapeType) {
                case DT_SHAPE_CIRCLE:
                    db.penLayer.addEventListener('mousedown', watchCircle);
                break;
                case DT_SHAPE_SQUARE:
                case DT_SHAPE_RECT:
                case DT_SHAPE_TRIANGLE:
                case DT_SHAPE_RIGHT_TRIANGLE:
                    db.penLayer.addEventListener('mousedown', watchRectTriangle);
                break;
                }
            break;
            case DT_TOOL_FREEHAND:
                db.penLayer.addEventListener('mousedown', watchFreehand);
            break;
            case DT_TOOL_ERASER:
                db.penLayer.addEventListener('mousedown', watchErase);
            break;
        }
    }
 }

export function setDrawObjToDefault() {

    db.pen = new DrawToolType(DT_DRAW_MODE,DT_TOOL_LINE,DT_END_POINT_NONE, 
        DT_END_POINT_NONE, DT_MULTI_LINE_JOINT_NONE,DT_SHAPE_CIRCLE, 
        DT_SHAPE_OUTLINE, DT_LINE_OPACITY_HIGHLIGHT_2, DT_LINE_SIZE_2, 
        DT_COLOR_1, DT_HIGHLIGHT_LINE_SIZE_3, DT_COLOR_15, DT_LINE_TYPE_SOLID,
        DT_HIGHLIGHT_OFF);

}



// Make the pen layer inactive, and return the math problems to active
export function disablePen() {

    // check if user clicked end draw in middle of multi-line, finish it if so
    if (db.state == STATE_IN_DRAW_MULTI) { //} && db.curPenIndex > 0 && db.pen.toolType == DT_TOOL_MULTI) {
        finishMultiLine();
    }
    db.inPen = false;

    //db.penBackground
    //console.log("DISABLE PEN", db.curPenIndex); // db.penItemList[db.curPenIndex].pointsVisible);

    // check if any editing background shapes or points are shown, and hide if so
    if (db.penItemList.length > 0 && db.penItemList[db.curPenIndex].pointsVisible) {
        hideEditPoints(db.penItemList[db.curPenIndex]);
        //clearPenMoveObj(db.penItemList[db.curPenIndex]);
    }  
    if (db.penBackground != null && db.penBackground.length > 0) {  
        db.penBackground.pointsVisible = false;
    }
    if (db.penLayer != null) {
        db.penLayer.removeAllEventListeners();
        removeStageDrawingHandlers();
        movePenLayerBehindMath();
    }
    let canvas = document.getElementById('drawingboard');
    canvas.classList.remove("grab-cursor");
    canvas.classList.remove("grabbing-cursor");
    canvas.classList.add("default-cursor");
   
    doStageUpdate();
}

// assign the canvas pen tool values to those passed in from angular Draw Tool
export function setPenTool(drawToolObj) {
    //console.log("in setPenTool", db.pen);
    // check if edit points of current pen object are shown, and hide them if shown


    // check if user clicked end draw in middle of multi-line, finish it if so
    if (db.state == STATE_IN_DRAW_MULTI) {
        //console.log("finish");
        finishMultiLine();
    }
  
    if (db.curPenIndex >= 0 && db.penItemList[db.curPenIndex] != null &&
        db.penItemList[db.curPenIndex].pointsVisible) {
        hideEditPoints(db.penItemList[db.curPenIndex]);
    }

    // change the event watchers if change tool type or to editing
    if (db.pen.toolType != drawToolObj.toolType || drawToolObj.drawMode == DT_EDIT_MODE
        || db.pen.drawMode == DT_EDIT_MODE ||
        (db.pen.toolType == DT_TOOL_SHAPE && db.pen.shapeType != drawToolObj.shapeType)) {
    
        db.penLayer.removeAllEventListeners();
        removeStageDrawingHandlers();    
        db.pen = Object.assign({}, drawToolObj)
        if (db.pen.drawMode == DT_EDIT_MODE) {
            choosePenWatcher();
        }
        else if (db.pen.toolType == DT_TOOL_ERASER) {
            choosePenWatcher();
        }
        else {
            // maybe have states for edit/eraser?
            //db.inPen = true;
            choosePenWatcher() 
        }
    }
    else {
        db.pen = Object.assign({}, drawToolObj);
    }
}

function watchPoint(e) {
    //console.log("in watchPoint", db.pen, db.pen.regLineSize);

    let penPt = getCorrectXY(db.penLayer);
    let penItem = setupNewPenItem(penPt);
  
    let ptObj = penItem.shape;
    
    setPenShapeFill(ptObj,db.pen,true);
    // need to figure out the right sizes for points
    let size= (db.pen.highlight == DT_HIGHLIGHT_ON) ? db.pen.highlightLineSize : db.pen.regLineSize;
    ptObj.graphics.drawCircle(0,0,2 + size/2);
    penItem.container.addChild(ptObj);
    //ptObj.addEventListener("mousedown",handleMovePoint);
   
    penItem.state = STATE_NORMAL_PEN_ITEM;
    db.fileChanged = true;
    
    //cvGetDataUndoPush();

    doStageUpdate();
    // save to both window cache and undo stack - true arguement does undo push
    if (db.state != STATE_OPEN_FILE) {
        window.fileManagerService.updateCurrentFileData(cvGetFileDataToSave(null, true))
    }
}

// event handler for watching and drawing a Circle, from mouse drag
function watchCircle(e) {

    let startPt = getCorrectXY(db.penLayer);
    let penItem = setupNewPenItem(startPt);
  
    let nextPt;
    let radius = 0;
    // set up the createjs pen object for drawing
    let newShape = penItem.shape;
    penItem.container.addChild(newShape);

    // adjust circle size as user drags mouse
    db.penLayer.addEventListener("pressmove", function (e) {
       
        nextPt = getCorrectXY(db.penLayer);
        radius = Math.sqrt(Math.pow(nextPt.x - startPt.x, 2) + Math.pow(nextPt.y - startPt.y, 2));
         // save - for polyfill's here' show to calculate the angle between the starting point and current mouse position
         //var angle = Math.atan2(nextPt.y - startPt.y, nextPt.x - startPt.x) * (180 / Math.PI);
        
        newShape.graphics.clear();
        setPenShapeStroke(newShape,db.pen); 
        setPenShapeFill(newShape,db.pen);
        
        // save for polystar, here's the call
        //newShape.graphics.drawPolyStar(startPt.x, startPt.y, radius,3,0,angle);
        newShape.graphics.drawCircle(0,0,radius);
        doStageUpdate();
       
    })
    db.penLayer.addEventListener("pressup", function (e) {

        db.penLayer.removeAllEventListeners('pressmove');
        db.penLayer.removeAllEventListeners('pressup');
        // if user only clicked, then draw default size circle
        if (radius == 0) {
            removeIncompleteLastPenItem();
            window.translateService.get('ERROR.cvPenShapeDrag').subscribe(translatedValue => {
                window.toastService.showError(translatedValue);
            })
        }
        else {
            pushPenItemPt(penItem,radius,0);
            //watchEditDragPoints(penItem);
            penItem.radius = radius;
            
            // push undo object to undo stack
            penItem.state = STATE_NORMAL_PEN_ITEM;
            db.fileChanged = true;
            if (db.state != STATE_OPEN_FILE) {
                window.fileManagerService.updateCurrentFileData(cvGetFileDataToSave(null, true))
            }
        }

    })
    
}  

// event handler for watching and drawing rectangle and triangle shapes, from mouse drag
function watchRectTriangle(e) {

    stage.enableMouseOver(20);

    let startPt = getCorrectXY(db.penLayer);
    let penItem = setupNewPenItem(startPt);
    let nextPt = null;
    let width, height, size;
    let newShape = penItem.shape;

    // adjust shape size as user drags mouse
    db.penLayer.addEventListener("pressmove", function (e) {
        //("got press move");
       
        nextPt = getCorrectXY(db.penLayer); 
        newShape.graphics.clear();
        //setPenShapeStroke(newShape,db.pen,true); 
        setPenShapeFill(newShape,db.pen);
       
        width = nextPt.x-startPt.x;
        height = nextPt.y-startPt.y;
        if (db.pen.shapeType == DT_SHAPE_RECT) {
            setPenShapeStroke(newShape,db.pen); 
            newShape.graphics.drawRect(0,0,width, height);
        }
        if (db.pen.shapeType == DT_SHAPE_SQUARE) {
            let size = Math.min(Math.abs(width),Math.abs(height));
            width = size * Math.sign(width);
            height = size * Math.sign(height);
            setPenShapeStroke(newShape,db.pen); 
            newShape.graphics.drawRect(0,0,width,height);
        }
        else if (db.pen.shapeType == DT_SHAPE_TRIANGLE) {
            setPenShapeStroke(newShape,db.pen,true); 
            newShape.graphics.moveTo(0,0).lineTo(width, height);
            newShape.graphics.lineTo(-width, height).lineTo(0,0);
        }
        else if (db.pen.shapeType == DT_SHAPE_RIGHT_TRIANGLE) {
            setPenShapeStroke(newShape,db.pen,true); 
            newShape.graphics.moveTo(0,0).lineTo(width, height);
            newShape.graphics.lineTo(0, height).lineTo(0,0);
        }
        doStageUpdate();
       
    })
    db.penLayer.addEventListener("pressup", function (e) {
       // console.log("got press up");

        // if user only clicked, then draw default size circle
        if (nextPt == null) {
            removeIncompleteLastPenItem();
            window.translateService.get('ERROR.cvPenShapeDrag').subscribe(translatedValue => {
                window.toastService.showError(translatedValue);
            })
            db.penLayer.removeAllEventListeners('pressmove');
            db.penLayer.removeAllEventListeners('pressup');
            return;
        }
      
        // save needed values in penItem for file saving
        penItem.width = width;
        penItem.height = height;
        db.curPenObj = newShape;
        
        if (db.pen.shapeType ==DT_SHAPE_TRIANGLE || db.pen.shapeType == DT_SHAPE_RIGHT_TRIANGLE ){
            pushPenItemPt(penItem,0,0);
            pushPenItemPt(penItem,width, height);
            if (db.pen.shapeType == DT_SHAPE_TRIANGLE) {
                pushPenItemPt(penItem,-width, height); 
            }
            else if (db.pen.shapeType == DT_SHAPE_RIGHT_TRIANGLE) {
                pushPenItemPt(penItem, 0, height);
            }
            pushPenItemPt(penItem,0,0)
            watchEditDragPoints(penItem);
           
            
        }
        // while rectangles aren't drawn from points, save them anyway for the edit point locations
        else if (db.pen.shapeType ==DT_SHAPE_RECT || db.pen.shapeType == DT_SHAPE_SQUARE ){
            pushPenItemPt(penItem,0,0);
            pushPenItemPt(penItem,width, 0);
            pushPenItemPt(penItem,width,height)
            pushPenItemPt(penItem,0,height)
            
           
            //if (db.pen.highlight == DT_HIGHLIGHT_OFF) {
            //    watchEditDragPoints(penItem);
            //}
        }
    
        // cancel extra listeners until get another press down
        db.penLayer.removeAllEventListeners('pressmove');
        db.penLayer.removeAllEventListeners('pressup');

        
        penItem.state = STATE_NORMAL_PEN_ITEM;
        db.fileChanged = true;

        // push file onto window cache and undo object to undo stack
        if (db.state != STATE_OPEN_FILE) {
            window.fileManagerService.updateCurrentFileData(cvGetFileDataToSave(null, true))
        }
        
    })

  
}  

// setup the creatjs and penItem data structures for a new pen item 
function setupNewPenItem(startPt) {

    // hide any prior pen item before creating this one
    if (db.curPenIndex >= 0 && db.penItemList.length > 0 && db.penItemList[db.curPenIndex].pointsVisible) {
        hideEditPoints(db.penItemList[db.curPenIndex]);
    }

    let penItem = new PenItemType();
    penItem.initPenItem(startPt);
    penItem.container = new createjs.Container();
    db.curPenContainer = penItem.container;
    db.penLayer.addChild(penItem.container);
    db.curPenIndex = db.penItemList.length-1;

    //let newShape = new createjs.Shape();
    //newShape.name = db.curPenIndex;   // use index into db array to find penItem in case of erase

    penItem.shape = new createjs.Shape();
    penItem.shape.name = db.curPenIndex;
    penItem.container.addChild(penItem.shape);
    penItem.shape.x = startPt.x;
    penItem.shape.y = startPt.y;
    doStageUpdate();
    db.fileChanged = true;
    //console.log("setupNewPenItem", penItem.shape.name, penItem);

    return(penItem);

}

function watchSingleLine(e) {
   
    let startPt = getCorrectXY(db.penLayer);
    //console.log("got single press down", startPt.x, startPt.y);
    let penItem = setupNewPenItem(ZERO_PT)
    pushPenItemPt(penItem,startPt.x, startPt.y);
    
    let nextPt;
    let newPenLine = penItem.shape;
    newPenLine.x = newPenLine.y = 0;
   
    //newPenLine.graphics.setStrokeStyle(db.pen.regLineSize, 'round', 'round'); //db.pen.regLineSize);
    
    db.penLayer.addEventListener("pressmove", function (e) {
        
        nextPt = getCorrectXY(db.penLayer);
        
        newPenLine.graphics.clear();
        //console.log("check obj",penItem.endLineObj)
        //console.log("in drawline", penItem.startLineObj,penItem.endLineObj);
        if (penItem.endLineObj != null) {
            db.curPenContainer.removeChild(penItem.endLineObj);
        }
        if (penItem.startLineObj != null) {
            db.curPenContainer.removeChild(penItem.startLineObj);
        }
       
        setPenShapeStroke(newPenLine,db.pen); 
        //newPenLine.graphics.setStrokeStyle(db.pen.regLineSize).beginStroke(db.pen.regColor); 

        let adjustStartPt = adjustStart(penItem,startPt,nextPt);
        newPenLine.graphics.moveTo(adjustStartPt.x, adjustStartPt.y); // adjustEnd(penItem,nextPt));
        let adjustEndPt = adjustEnd(penItem,nextPt,startPt);
        newPenLine.graphics.lineTo(adjustEndPt.x, adjustEndPt.y)
        //console.log("in draw penitem", penItem);
        penItem.startLineObj = addEndLineShape(penItem, startPt, nextPt,penItem.dt.lineStartType, true);
        // draw end shape if the line is long enough to do this easily
        if (Math.abs(nextPt.x - startPt.x) > 5 || Math.abs(nextPt.y - startPt.y) > 5 ) {
            penItem.endLineObj = addEndLineShape(penItem, nextPt, startPt, penItem.dt.lineEndType);
        }
        doStageUpdate();
      
    })
    db.penLayer.addEventListener("pressup", function (e) {
        
        // save the second point as long as the user moved the mouse
        if (nextPt != null && (nextPt.x != startPt.x || nextPt.y != startPt.y)) {
            pushPenItemPt(penItem,nextPt.x, nextPt.y);
        }
        else {  // if no movement then remove this draw object
            removeIncompleteLastPenItem();
            window.translateService.get('ERROR.cvPenLineDrag').subscribe(translatedValue => {
                window.toastService.showError(translatedValue);
            })
            db.penLayer.removeAllEventListeners('pressmove');
            db.penLayer.removeAllEventListeners('pressup');
            return;
        }
     
        db.penLayer.removeAllEventListeners('pressmove');
        db.penLayer.removeAllEventListeners('pressup');

        // push to und
        penItem.state = STATE_NORMAL_PEN_ITEM;
        db.fileChanged = true;

        // push file onto window cache and undo object to undo stack
        if (db.state != STATE_OPEN_FILE) {
            window.fileManagerService.updateCurrentFileData(cvGetFileDataToSave(null, true))
        }
    })

}  



// draw a line or multi-line end shape at startPt, with arrows along the line defined by 
// startPt to endPt
function addEndLineShape( penItem, startPt, endPt, endType, isStart) {    
    
    if (endType == DT_END_POINT_NONE || (penItem.dt.toolType == DT_TOOL_MULTI_LINE && penItem.dt.jointType == DT_MULTI_LINE_CLOSED)) {
        return(null)
    }
  
    let shapeObj = new createjs.Shape();
    shapeObj.x = startPt.x;
    shapeObj.y = startPt.y;
    //console.log("in addEndLine", db.curPenIndex);
    shapeObj.name = db.curPenIndex;// use to find objects in erase
    shapeObj.ptIndex = 1; // temp
    if (endType != DT_END_POINT_OPEN_DOT) {
        setPenShapeFill(shapeObj,penItem.dt,true);
        //shapeObj.graphics.beginFill(penItem.dt.regColor);
    }
    else {
        setPenShapeStroke(shapeObj,penItem.dt); 
        // always set stroke size to 1 for open circles
        shapeObj.graphics.setStrokeStyle(1);
        //shapeObj.graphics.setStrokeStyle(5); //penItem.dt.regLineSize);
    }
     
    let arrowDot = false;
    let arrowSize;
    let adjustPt;
    switch (endType) {
        case DT_END_POINT_DOT:
        case DT_END_POINT_OPEN_DOT:

            // need to figure out the right sizes for points
            shapeObj.graphics.drawCircle(0,0,2 + penItem.dt.regLineSize);
            penItem.container.addChildAt(shapeObj,0);

            break;
            
        case DT_END_POINT_ARROW_DOT:

            if (isStart) {
            adjustPt = adjustStart(penItem,startPt, endPt,true);
            }
            else {
                adjustPt = adjustEnd(penItem,startPt, endPt, true);
            }
            arrowSize = (penItem.dt.highlight == DT_HIGHLIGHT_OFF) ? penItem.dt.regLineSize : penItem.dt.highlightLineSize;
            arrowSize = arrowSize*2 + 10;
            // pass points in reversed order for arrows
     
            addEndLineArrow(penItem,shapeObj,endPt, adjustPt, arrowSize);
            break;
         
          
        case DT_END_POINT_ARROW:
            arrowSize = (penItem.dt.highlight == DT_HIGHLIGHT_OFF) ? penItem.dt.regLineSize : penItem.dt.highlightLineSize;
            arrowSize = arrowSize*2 + 10;
            // pass points in reversed order for arrows
            addEndLineArrow(penItem,shapeObj,endPt, startPt, arrowSize);
            break;
    }
   doStageUpdate();
  
    return (shapeObj);
}

function addEndLineArrow( penItem,triangle, startPt, endPt, triangleLength) {
    //console.log("in addend", startPt, endPt);

    // Calculate the angle of the line
    var angle = Math.atan2(endPt.y - startPt.y, endPt.x - startPt.x);
    
    triangle.x = 0;
    triangle.y = 0;

    var triangleHeight = triangleLength; // The length along the line
    var triangleBase = triangleLength / 2; // The width perpendicular to the line

    // Calculate the points of the triangle
    var pt1 = {
        x: endPt.x,
        y: endPt.y
    };
    var pt2 = {
        x: endPt.x - triangleHeight * Math.cos(angle) + triangleBase * Math.sin(angle),
        y: endPt.y - triangleHeight * Math.sin(angle) - triangleBase * Math.cos(angle)
    };
    var pt3 = {
        x: endPt.x - triangleHeight * Math.cos(angle) - triangleBase * Math.sin(angle),
        y: endPt.y - triangleHeight * Math.sin(angle) + triangleBase * Math.cos(angle)
    };

    //console.log("Points", pt1,pt2,pt3);
    // Draw the triangle
    triangle.graphics.moveTo(pt1.x, pt1.y);
    triangle.graphics.lineTo(pt2.x, pt2.y);
    triangle.graphics.lineTo(pt3.x, pt3.y);
    triangle.graphics.lineTo(pt1.x, pt1.y);
    triangle.graphics.endFill();

    // Add both shapes to the stage
  
    penItem.container.addChild(triangle);

    // Update the stage
    doStageUpdate();
}


function removeStageDrawingHandlers() {
    stage.removeAllEventListeners("stagemousemove");
    stage.removeAllEventListeners("stagemouseup");
    stage.removeAllEventListeners("stagemousedown");
    stage.removeAllEventListeners("dblclick");
    //stage.enableMouseOver(0);
}

// function watchMultiLine sets event handlers and manages drawing a multiLine
// The user clicks for each point however a temporary line after each click to current mouse position
// as feedback to user.  The user can end the drawn object either by double-clicking or moving the mouse 
// off the canvas, such as to click the pen icon
export function watchMultiLine() {

let penItem;
let nextPt;
let priorPt; 
let newPenLine, curMousePt;
let tempLine = null;
let index;
let startPressPt;
let tempEnd;
let gotEndLongPress = false;
let tempPressCircle = null;

  //db.penLayer.addEventListener("click", function(e) {
  db.penLayer.addEventListener("mousedown", function(e) {
    //console.log("got mouse down");
    startPressPt = getCorrectXY(db.penLayer);
    // start timeout to watch for long clicks ending the object
    db.state = STATE_IN_DRAW_MULTI;
    db.penMultiTimer = setTimeout(multiLineTimeout,2000); 

    db.penLayer.addEventListener("pressup", function(e) {
        e.stopImmediatePropagation();
        e.preventDefault();
        //console.log("got press up");

        // for the first click, create the needed createjs and db structures
        // can't do this earlier since user could never actually start a multiLine
        // also remove any temp indicator of the long press
        clearTimeout(db.penMultiTimer);
        if (tempPressCircle != null) {
            penItem.container.removeChild(tempPressCircle);
            tempPressCircle == null;
        }
    
        if (penItem == null) {
            nextPt = getCorrectXY(db.penLayer);
    
            penItem = setupNewPenItem(ZERO_PT);
            penItem.state = STATE_DRAW_PEN_ITEM;
            // first point so set priorPt to this one
            priorPt = new cvPointType(nextPt.x, nextPt.y);
            pushPenItemPt(penItem,nextPt.x, nextPt.y);

            newPenLine = penItem.shape;
    
            // assign shapes for the mousemove temporary lines as user feedback
            tempLine = new createjs.Shape();
            tempLine.x = newPenLine.y = 0;
            penItem.container.addChild(tempLine);
            let tempStartPt = new cvPointType( nextPt.x + 30, nextPt.y);
            penItem.tempLine = tempLine;

            // start listener for if user clicks on sidebar or leaves canvas then end multi-Line object
            stage.addEventListener('mouseleave', handleMouseLeave); 
            db.penLayer.addEventListener("dblclick", handleDblclick);
            tempEnd = (penItem.dt.lineStartType != DT_END_POINT_NONE) ? penItem.dt.lineStartType : DT_END_POINT_DOT;
            penItem.startLineObj = addEndLineShape(penItem, nextPt, tempStartPt, tempEnd, true);
        }
        else {
            // don't change the createjs order due to createjs weirdness about stroke definitions on changing objects
            setPenShapeStroke(newPenLine,penItem.dt,true);
            if (penItem.points.length == 1) {
                nextPt = getCorrectXY(db.penLayer);
                let adjustStartPt = adjustStart(penItem,priorPt,nextPt);
                newPenLine.graphics.moveTo(adjustStartPt.x, adjustStartPt.y); // adjustEnd(penItem,nextPt));
            }
            else {
                newPenLine.graphics.moveTo(nextPt.x, nextPt.y);
                nextPt = getCorrectXY(db.penLayer);
            }
        
            // since ending double clicks will also register as 2 single clicks first, 
            // ignore this click if it's the same location as the last one
            if (nextPt.x != priorPt.x && nextPt.y != priorPt.y) {
                //console.log("multi next click", nextPt, priorPt);
                pushPenItemPt(penItem,nextPt.x, nextPt.y);
                newPenLine.graphics.lineTo(nextPt.x, nextPt.y)

                // after second point, add the first end shape
                if (penItem.points.length ==2) {
                    penItem.container.removeChild(penItem.startLineObj);
                    penItem.startLineObj = addEndLineShape(penItem, penItem.points[0], nextPt, penItem.dt.lineStartType, true);
                }
                
                // add joint points for the point drawn previously, to prevent added to last one
                if (penItem.dt.jointType == DT_MULTI_LINE_JOINT_DOT && penItem.points.length > 2) {
                    addJointPoint(penItem.points[penItem.points.length-2], penItem, penItem.points.length-2);
                }

                doStageUpdate();
                priorPt.x = nextPt.x;
                priorPt.y = nextPt.y;
            }
        }
    
        
        // use stagemousemove to allow for drawing temporary lines
        stage.enableMouseOver(10);
        stage.addEventListener('stagemousemove',function (e) {
            //console.log("in stagemousemove");            
            drawTempLine();
        });

        function drawTempLine() {

            //console.log("in stagemousemove");            
            tempLine.graphics.clear();
            curMousePt = getCorrectXY(db.penLayer);
            if (tempPressCircle != null) {
                penItem.container.removeChild(tempPressCircle);
                tempPressCircle == null;
            }
          
            // clear the timeout watching for long presses to end multiLine but don't change if just a tiny move
            ///console.log(curMousePt, startPressPt,curMousePt.x - startPressPt.x,curMousePt.y - startPressPt.y );
            if ((curMousePt.x - startPressPt.x > 5) || curMousePt.y - startPressPt.y > 5) {
                //console.log("clear timer in mousemove");
                clearTimeout(db.penMultiTimer);
            }
            setPenShapeStroke(tempLine,penItem.dt);
        
            if (penItem.points.length == 1) {
                let adjustStartPt = adjustStart(penItem,priorPt,curMousePt);
                tempLine.graphics.moveTo(adjustStartPt.x, adjustStartPt.y); // adjustEnd(penItem,nextPt));
            }
            else {
                tempLine.graphics.moveTo(nextPt.x, nextPt.y);
            }
            tempLine.graphics.lineTo(curMousePt.x, curMousePt.y);

            if (penItem.points.length ==1) {
                penItem.container.removeChild(penItem.startLineObj);
                penItem.startLineObj = addEndLineShape(penItem, penItem.points[0], curMousePt, penItem.dt.lineStartType, true);
            }
            doStageUpdate();
        }

        if (gotEndLongPress) {
            drawTempLine();
            finishMultiLine();
        }   

    });

    // watch for long presses to end lines - needed for touch devices
    function multiLineTimeout() {
        if (curMousePt) {
            //console.log("got timeout multi",curMousePt);
            gotEndLongPress = true;
            tempPressCircle = new createjs.Shape;
            tempPressCircle.graphics.setStrokeStyle(5).beginStroke("green");
            tempPressCircle.name = "TempPress";
            tempPressCircle.graphics.drawCircle(curMousePt.x, curMousePt.y, 15);
        
            penItem.container.addChild(tempPressCircle);
            stage.update();
        }

    }
  });
}

function handleDblclick(e) {
    e.preventDefault();
    //console.log("got dbl click");
    finishMultiLine();
}

function handleMouseLeave(e) {
    finishMultiLine();
}



export function finishMultiLine() {

    clearTimeout(db.penMultiTimer);
    //console.log("finish multi");
    
  
    let penItem = db.penItemList[db.curPenIndex];
    let tempLine = penItem.tempLine;

    //remove temp press circle for odd cases such as on touch screens
    let tempShapeIndex = penItem.container.getChildByName("TempPress");
    penItem.container.removeChild(tempShapeIndex);
    stage.update();
  
    stage.enableMouseOver(0);
    penItem.container.removeChild(tempLine);
    
    // check if a line was drawn, and remove draw object if not
    if (penItem != null && penItem.points.length < 2) {
        removeIncompleteLastPenItem();
        window.translateService.get('ERROR.cvPenMultiLineClick').subscribe(translatedValue => {
            window.toastService.showError(translatedValue);
        })
        stage.removeAllEventListeners('stagemousemove');
        stage.removeEventListener('mouseleave',handleMouseLeave);
        //db.penLayer.removeAllEventListeners("dblclick");
        db.penLayer.removeAllEventListeners(); //"pressup");
        penItem = null;
    }
    else {

        //check for closed shapes and add an extra point for them
        if (penItem.dt.jointType == DT_MULTI_LINE_CLOSED) {

            //let lastPt = new cvPointType(penItem.points[0].x, penItem.points[0].y);
            pushPenItemPt(penItem,penItem.points[0].x, penItem.points[0].y);
            penItem.shape.graphics.lineTo(penItem.points[0].x, penItem.points[0].y);

        }
        else {
            // check if end object needs line adjustment - is so then redraw the whole line to do that
            if (penItem.dt.lineEndType != DT_END_POINT_NONE &&
                penItem.dt.lineEndType != DT_END_POINT_DOT) {
                    penItem.container.removeAllChildren();
                
                drawSavedPenItem(null, true, penItem);
                }
            else {
            penItem.endLineObj = addEndLineShape(penItem, penItem.points[penItem.points.length-1], 
                penItem.points[penItem.points.length-2], penItem.dt.lineEndType);
            }
        }
        
        stage.removeAllEventListeners('stagemousemove');
        stage.removeEventListener('mouseleave',handleMouseLeave);
        db.penLayer.removeAllEventListeners(); //"dblclick");
        db.fileChanged = true;

        penItem.state = STATE_NORMAL_PEN_ITEM;
        penItem = null;
        db.fileChanged = true;

        // push file onto window cache and undo object to undo stack
        if (db.state != STATE_OPEN_FILE) {
            window.fileManagerService.updateCurrentFileData(cvGetFileDataToSave(null, true))
        }
    }

    // restart watcher for multi-line
    db.state = STATE_NORMAL;
    watchMultiLine();
    doStageUpdate();
}



// If creating a pen object is interrupted before finished, then
// remove that last pen object and reset to the last complete and not deleted
// pen object.  Objects that are erased are kept and just marked deleted instead
function removeIncompleteLastPenItem() {

    let penIndex = db.curPenIndex;
    db.penLayer.removeChild(db.penItemList[penIndex].container);
    db.penItemList.pop();
   
    // find the last penItem to make current
    penIndex--;
    while (penIndex >= 0 && db.penItemList[penIndex].deleted) {
        penIndex--;
    }
    if (penIndex < 0) {
        //console.log("Empty pen list", db.penItemList);
        db.curPenIndex = -1;
    }
    else {
        db.curPenIndex = penIndex;
        db.curPenContainer = db.penItemList[penIndex].container;
        db.curPenObj = db.penItemList[penIndex].shape;
        //console.log("reset pen item", db.curPenIndex, db.curPenContainer, db.curPenObj, db.penItemList[db.curPenIndex]);
    }
}

export function unDoPartialPenItem() {

    // if undo on the last pen item drawn, then remove from the item list
    if (db.curPenIndex == db.penItemList.length-1)  {
        removeIncompleteLastPenItem();
    }
}

function addJointPoint(linePt, penItem, ptIndex) {

    if (penItem.jointsObj[ptIndex] != null) {
        penItem.container.removeChild(penItem.jointsObj[ptIndex]);
    }

    // set up the createjs pen object for drawing
    let newShape = new createjs.Shape();
    penItem.jointsObj[ptIndex] = newShape;
    //console.log(penItem.pointsObj);
    newShape.name = db.penItemList.length-1;   
    newShape.x = linePt.x;
    newShape.y = linePt.y;
    penItem.container.addChildAt(newShape,0);

    setPenShapeFill(newShape,penItem.dt,true);
    let radius = (penItem.dt.highlight == DT_HIGHLIGHT_OFF) ? penItem.dt.regLineSize : penItem.dt.highlightLineSize;
    radius = (radius < 6) ? radius+3 : radius;
   
    //console.log(radius);
    newShape.graphics.drawCircle(0,0, radius);
        
}



function watchFreehand(e) {
   
    let curPt = getCorrectXY(db.penLayer);
    //console.log("got freehand press down", curPt.x, curPt.y);
    let penItem = setupNewPenItem(ZERO_PT);
    pushPenItemPt(penItem,curPt.x, curPt.y);
   
    let nextPt;
    let i= 1;
    let lastX, lastY;
    let newSketch = penItem.shape;
    let strokeSize = penItem.dt.regLineSize
    newSketch.graphics.setStrokeStyle(strokeSize,'round', 'round');
    // always use regular color on freehand, because opacity just ends
    // up uneven and odd on freehand due to overlapping lines
    newSketch.graphics.beginStroke(penItem.dt.regColor);
    
    newSketch.graphics.moveTo(curPt.x, curPt.y);
    let count = 0
    let distance;
    db.penLayer.addEventListener("pressmove", function (e) {
    
        //lastX = curPt.x;
        //lastY = curPt.y;
        count++;
        nextPt = getCorrectXY(db.penLayer);
        let distance = getDistance (curPt, nextPt);
        // only add points when the mouse distance is over 5px, to avoid a createjs issue with rendering
        // thicker stroke thickness in this use
        if (distance > 5) {
            
            penItem.points.push(nextPt);
       
            newSketch.graphics.setStrokeStyle(strokeSize,'round', 'round');
            newSketch.graphics.moveTo(curPt.x, curPt.y).lineTo(nextPt.x, nextPt.y);
            curPt.x = nextPt.x;
            curPt.y = nextPt.y;
            pushPenItemPt(penItem,curPt.x, curPt.y);
            //newLine.graphics.lineTo(curPt.x, curPt.y);
            doStageUpdate();
        }
        // }
    })
    db.penLayer.addEventListener("pressup", function (e) {
        //console.log("freehand pressup", penItem.points);

        
        // remove incomplete individual clicks
        if (penItem.points.length < 2) {
            removeIncompleteLastPenItem();
            window.translateService.get('ERROR.cvPenFreehandDrag').subscribe(translatedValue => {
                window.toastService.showError(translatedValue);
            })
            db.penLayer.removeAllEventListeners('pressmove');
            db.penLayer.removeAllEventListeners('pressup');
            return;
        }
     
        newSketch.graphics.setStrokeStyle(strokeSize,'round', 'round');
        // test code to see if can fill freehand shapes
        //newSketch.graphics.beginFill("red");
        //let length = penItem.points.length;
        //newSketch.graphics.moveTo(penItem.points[length-1].x, penItem.points[length-1].y).lineTo(penItem.points[0].x, penItem.points[0].y);
        
        //db.penLayer.removeChild(newSketch);
        db.penLayer.removeAllEventListeners('pressmove');
        db.penLayer.removeAllEventListeners('pressup');
        doStageUpdate();
        
        // push to undo
        penItem.state = STATE_NORMAL_PEN_ITEM;

        // push file onto window cache and undo object to undo stack
        if (db.state != STATE_OPEN_FILE) {
            window.fileManagerService.updateCurrentFileData(cvGetFileDataToSave(null, true))
        }
       
    })
}  

function getDistance(p1, p2) {
    let dx = p2.x - p1.x;
    let dy = p2.y - p1.y;
    return Math.sqrt(dx * dx + dy * dy);
  }

 

function drawSavedCircleOrPoint(penItem, dt, newShape, isBackgroundDraw) {
    //console.log("draw saved circle", penItem, penItem.radius, dt);
    
    // draw circle shape
    if (dt.toolType == DT_TOOL_POINT) {
        setPenShapeFill(newShape,dt,true);
        let size= (dt.highlight == DT_HIGHLIGHT_ON) ? dt.highlightLineSize : dt.regLineSize;
        newShape.graphics.drawCircle(0,0,2 + size/2);
    }
    else {  // must be a circle shape
        setPenShapeStroke(newShape,dt); 
        setPenShapeFill(newShape,penItem.dt);
       
        newShape.graphics.drawCircle(0,0, penItem.radius);
    }
    
    penItem.container.addChild(newShape);

}  


function drawSavedRect(penItem,dt, newShape) {
   
    
    setPenShapeStroke(newShape,dt); 
    setPenShapeFill(newShape,dt);
   
    newShape.graphics.drawRect(0,0,penItem.width,penItem.height);
    penItem.container.addChild(newShape);
    doStageUpdate();
}  


export function drawSavedPenItem(filePenItem, fromEdit, penItem,backShapeDt) {

    //console.log("draw saved line of shape",filePenItem, penItem);
 
    let startPt; 
  
    let index, dt;
    let isBackgroundDraw; 
   
    if (!fromEdit) {
        // set up the db structure pen object for file saving and tracking
        penItem = new PenItemType();
        startPt = new createjs.Point(filePenItem.x, filePenItem.y);
        penItem.initFromFilePenItem(startPt,filePenItem.dt);
        penItem.radius = filePenItem.radius;            // radius for circles
        penItem.width = filePenItem.width;              // width for shapes
        penItem.height = filePenItem.height;  

        penItem.container = new createjs.Container();
        penItem.container.x = filePenItem.offsetX;
        penItem.container.y = filePenItem.offsetY;
        //db.curPenContainer = penItem.container;
        db.penLayer.addChild(penItem.container);
        db.curPenIndex = db.penItemList.length-1;
        penItem.copyPenPoints(filePenItem);
    }
    else {
        //db.curPenIndex = db.penItemList.length-1; // change to penItem.myIndex;
        startPt = new createjs.Point(penItem.x, penItem.y);
        
    }
    db.curPenContainer = penItem.container;
  
    // set up the createjs pen object for drawing
    let newShape = new createjs.Shape();
    db.curPenObj = newShape;

    // if creating a background shape to detect a move item edit, then use the draw tool obj for background,
    // otherwise use the normal one associated with penItem
    if (!backShapeDt) {
        dt = penItem.dt;
        penItem.shape = newShape;
        isBackgroundDraw = false;
    }
    else {
        dt = backShapeDt;
        isBackgroundDraw = true;
    }
     //console.log("current pen index",db.curPenIndex);
    newShape.name = db.curPenIndex;  // use index into db array to find penItem in case of erase
    newShape.x = startPt.x;
    newShape.y = startPt.y;

    // draw the specific shape/pen item
    switch (dt.toolType) {
        case DT_TOOL_LINE: 
        case DT_TOOL_MULTI_LINE:
        case DT_TOOL_FREEHAND:
            drawSavedShapeFromPoints(penItem, dt, newShape, isBackgroundDraw);
        break;
        case DT_TOOL_POINT:
            drawSavedCircleOrPoint(penItem,dt,newShape, isBackgroundDraw);
        break;
        case DT_TOOL_SHAPE:
            if (dt.shapeType == DT_SHAPE_TRIANGLE || dt.shapeType == DT_SHAPE_RIGHT_TRIANGLE) {
                drawSavedShapeFromPoints(penItem, dt, newShape, isBackgroundDraw);
            }
            else if (dt.shapeType == DT_SHAPE_CIRCLE) {
                drawSavedCircleOrPoint(penItem,dt,newShape, isBackgroundDraw);
            }
            else if (dt.shapeType == DT_SHAPE_RECT || dt.shapeType == DT_SHAPE_SQUARE) {
                drawSavedRect(penItem,dt,newShape, isBackgroundDraw); 
            }
        break;
    }

    if (!backShapeDt) {
        db.curPenContainer.addChildAt(newShape,0);
    }
    else {
        newShape.alpha = .5;
        db.curPenContainer.addChildAt(newShape,1);
        //newShape.addEventListener('mousedown',watchMoveEditedPenObj);
    }
     doStageUpdate();
    return(newShape);
   
}


function drawSavedShapeFromPoints(penItem, dt, newShape, isBackgroundDraw) {

    let adjustEndFlag = false;
    // if it's a triangle then set the corners to be rounded
    if (dt.toolType == DT_TOOL_MULTI_LINE ||
        (dt.toolType == DT_TOOL_SHAPE && 
        (dt.shapeType == DT_SHAPE_TRIANGLE) || (dt.shapeType == DT_SHAPE_RIGHT_TRIANGLE))) {
        setPenShapeStroke(newShape,dt,true); 
        }
    else {
        setPenShapeStroke(newShape,dt); 
    }
    setPenShapeFill(newShape,dt);
 
    // check for lines with open circle dots, which need line length adjusted
    // and set starting position 
    let adjustStartPt;
    if ((dt.toolType == DT_TOOL_LINE || dt.toolType == DT_TOOL_MULTI_LINE) && 
        (dt.lineStartType == DT_END_POINT_OPEN_DOT || dt.lineStartType == DT_END_POINT_ARROW ||
        dt.lineStartType == DT_END_POINT_ARROW_DOT)) {
        // && (penItem.points.length > 1)) {
    
            adjustStartPt = adjustStart(penItem,penItem.points[0], penItem.points[1]);
            newShape.graphics.moveTo(adjustStartPt.x, adjustStartPt.y); 
            //penItem.startLineObj = addEndLineShape(penItem, startPt, nextPt,dt.lineStartType,true);
            //newShape.graphics.moveTo(penItem.points[0].x, penItem.points[0].y);
        }
    else {

        newShape.graphics.moveTo(penItem.points[0].x, penItem.points[0].y);
    }
    
    let lastForLoop = penItem.points.length-1;

    if ((dt.toolType == DT_TOOL_LINE || dt.toolType == DT_TOOL_MULTI_LINE) &&
        (dt.lineEndType == DT_END_POINT_OPEN_DOT || dt.lineEndType == DT_END_POINT_ARROW ||
            dt.lineEndType == DT_END_POINT_ARROW_DOT )
        && penItem.points.length > 1) {
            adjustEndFlag = true;
            lastForLoop--; 
    }
 
    // newShape.graphics.moveTo(penItem.points[0].x, penItem.points[0].y);
    for (let i = 1; i <= lastForLoop; i++) {
        newShape.graphics.lineTo(penItem.points[i].x, penItem.points[i].y);
    }

    //let adjustEndPt;
    if (adjustEndFlag) {
        let adjustEndPt = adjustEnd(penItem,penItem.points[penItem.points.length-1], penItem.points[penItem.points.length-2]);
        newShape.graphics.lineTo(adjustEndPt.x, adjustEndPt.y)

    }

    // if not a background shape redraw end shapes
    if ( !isBackgroundDraw && (dt.toolType == DT_TOOL_LINE || dt.toolType == DT_TOOL_MULTI_LINE)) {
        penItem.container.removeChild(penItem.startLineObj);
        penItem.container.removeChild(penItem.endLineObj);
        //console.log(dt.lineStartType, penItem, db.curPenIndex);
        penItem.startLineObj = addEndLineShape(penItem, penItem.points[0], penItem.points[1],dt.lineStartType, true);
     
        if (penItem.points.length > 1) {
            penItem.endLineObj = addEndLineShape(penItem, penItem.points[penItem.points.length-1],
                penItem.points[penItem.points.length-2], dt.lineEndType);
        }
        //penItem.endLineObj = addEndLineShape(penItem, penItem.points[1],
        //      penItem.points[0],dt.lineEndType);
    }

    // add joint points to center points on multi-line if indicated 
    if (!isBackgroundDraw && (dt.jointType == DT_MULTI_LINE_JOINT_DOT)) {
        for (let i = 1; i < penItem.points.length-1; i++) {
            addJointPoint(penItem.points[i], penItem, i);
        }
    }
 
}


function watchErase(e) {
    //("got erase press down");

    let curPt = getCorrectXY(db.penLayer);
    checkAndErase(curPt);

    db.penLayer.addEventListener('pressmove', function (e) {
        //console.log("erase move");
        curPt = getCorrectXY(db.penLayer);
        checkAndErase(curPt);   
        doStageUpdate();
    })  
    db.penLayer.addEventListener("pressup", function (e) {
        db.penLayer.removeAllEventListeners('pressmove');
        db.penLayer.removeAllEventListeners('pressup');
    })
}    

function checkAndErase(point) {
    let topObj = db.penLayer.getObjectUnderPoint(point.x,point.y);
    //console.log(topObj.name, topObj);
    let topPenItem = db.penItemList[topObj.name];
    
    if (topObj != null && topObj.name != "pen background") {
        topPenItem.deleted = true;
        db.penLayer.removeChild(topPenItem.container);

        db.fileChanged = true;
         // push file onto window cache and undo object to undo stack
         if (db.state != STATE_OPEN_FILE) {
            window.fileManagerService.updateCurrentFileData(cvGetFileDataToSave(null, true))
        }
    
        doStageUpdate();
    }
}    


